window.addEventListener('DOMContentLoaded', function () {

	//reviews-card-carousel
	const options = {
		type: 'loop',
		autoplay: true,
		interval: 4000,
		perPage: 2,
		perMove: 1,
		gap: '24px',
		pagination: false,
		breakpoints: {
			1200: {
				gap: '16px',
			},
			850: {
				perPage: 1,
			},
		},
	}

	document.querySelectorAll('.js-reviews-card-carousel').forEach(el => {
		el.splide = new Splide(el, options).mount();
	});


	//review-carousel
	var splideReview = new Splide('.js-review-carousel', {
		type: 'loop',
		autoplay: true,
		interval: 4000,
		pagination: false,
		gap: '24px'
	});
	splideReview.mount();


	//benefit-carousel
	let splideBenefit = new Splide('.js-benefit-carousel', {
		type: 'loop',
		autoplay: true,
		interval: 4000,
		perPage: 3,
		perMove: 1,
		gap: '24px',
		pagination: false,
		breakpoints: {
			1024: {
				gap: '10px',
			},
			767: {
				perPage: 2,
			},
			500: {
				perPage: 1,
			},
		},
	});

	splideBenefit.mount();


	//awards-carousel
	let splideAwards = new Splide('.js-awards-carousel', {
		type: 'loop',
		autoplay: true,
		interval: 4000,
		perPage: 3,
		perMove: 1,
		gap: '34px',
		pagination: false,
		breakpoints: {
			900: {
				perPage: 2,
				gap: '24px',
			},
			500: {
				perPage: 1,
			}
		},
	});

	splideAwards.mount();

});